// extracted by mini-css-extract-plugin
export default {"oid":"style_oid__AxXAE","itemName":"style_itemName__yZDB7","menu":"style_menu__THASe","search":"style_search__9E5wI","externalCodeList":"style_externalCodeList__ryLHR"};